import { useTranslation } from "react-i18next";

/** Compact empty state for the manager team widget on the employee dashboard right bar. */
function ManagerTeamTodosEmptyState() {
  const { t } = useTranslation();
  return (
    <p className="text-sm text-gray-500 py-1">
      {t("DashboardRightBar.ManagerTodosAllCaughtUp")}
    </p>
  );
}

export default ManagerTeamTodosEmptyState;
